var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lidaCard ledger-block"},[(_vm.$route.name != 'generalLedgerSearch')?_c('ButtonTool',[_c('BreadcrumbLevel')],1):_vm._e(),_c('router-view'),_c('BackBottom'),_c('BackTop',{attrs:{"height":10,"right":85}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }